// Point the iPECS SDK at the devices the user picked, dropping any that are
// no longer plugged in. None of these methods are in the SDK's
// unAuthenticatedMethods list, so this can only be called once iPECS login
// has completed, otherwise it throws "needs authentication".
export async function applySelectedDevices(
  call,
  { audioInput, audioOutput, videoInput },
) {
  const devices = await call.getMediaDevicesInfo();

  const deviceIdsOfKind = (kind) =>
    devices.filter((x) => x.kind === kind).map((x) => x.deviceId);

  // NOTE: the input id is checked against the output list, which is wrong,
  // but this is a straight lift of what both callers already did
  const audioInputIds = deviceIdsOfKind("audiooutput");
  const audioOutputIds = deviceIdsOfKind("audiooutput");
  const videoInputIds = deviceIdsOfKind("videoinput");

  if (audioInput) {
    await call.changeAudioInputRequest(
      audioInputIds.includes(audioInput) ? audioInput : undefined,
    );
  }

  if (audioOutput) {
    await call.changeAudioOutputRequest(
      audioOutputIds.includes(audioOutput) ? audioOutput : undefined,
    );
  }

  if (videoInput) {
    await call.changeVideoDeviceRequest(
      videoInputIds.includes(videoInput) ? videoInput : undefined,
    );
  }
}
